import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import Drip from 'drip';
import KNB from '@dp/knb';
import UA from 'drip/ua';
import cmblapi from '@myfe/cmblapi';
export function replaceUrl(targetHtml, url) {
  var pathName = location.pathname;
  var spearArr = pathName.split('/');
  spearArr[spearArr.length - 1] = targetHtml;
  return "".concat(location.protocol, "//").concat(location.host).concat(spearArr.join('/'));
}
export function paddingLeft(num) {
  var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var str = num + '';
  var s = '0000000000';
  if (str.length < len) {
    str = s.substr(0, len - str.length) + str;
  }
  return str;
}
export function computerDate(interval, number, date) {
  if (typeof date === 'string' || typeof date === 'number') date = new Date(date);
  if (date.toString() === 'Invalid Date') throw new Error('Argument [ date ] is illegal, please change it.');
  switch (interval) {
    case 'year':
      {
        date.setFullYear(date.getFullYear() + number);
        break;
      }
    case 'quarter':
      {
        date.setMonth(date.getMonth() + number * 3);
        break;
      }
    case 'month':
      {
        date.setMonth(date.getMonth() + number);
        break;
      }
    case 'week':
      {
        date.setDate(date.getDate() + number * 7);
        break;
      }
    case 'day':
      {
        date.setDate(date.getDate() + number);
        break;
      }
    case 'hour':
      {
        date.setHours(date.getHours() + number);
        break;
      }
    case 'minutes':
      {
        date.setMinutes(date.getMinutes() + number);
        break;
      }
    case 'seconds':
      {
        date.setSeconds(date.getSeconds() + number);
        break;
      }
    default:
      {
        date.setDate(date.getDate() + number);
        break;
      }
  }
  return date;
}
export function getTimeText(time_in_second, format) {
  var time = {};
  // hour
  time.h = Math.floor(time_in_second / 3600);
  var second = time_in_second % 3600;
  // minute
  time.m = Math.floor(second / 60);
  // second
  time.s = Math.ceil(second % 60);
  for (var key in time) {
    if (new RegExp('(' + key + '+)').test(format)) {
      format = format.replace(RegExp.$1, this.paddingLeft(time[key], RegExp.$1.length));
    }
  }
  return format;
}
export function random(start, end) {
  return Math.floor(start + Math.random() * (end - start + 1));
}
export function getCookie(cname) {
  var name = cname + '=';
  var c;
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    c = ca[i].trim();
    if (c.indexOf(name) === 0) {
      return c.split('=')[1];
    }
  }
  return undefined;
}
export function timeFormat(time) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'hh:mm';
  if (typeof time === 'string') {
    if (!/:/.test(time)) throw new Error("#{time} is not a time string !");
    return dateFormat('1971/01/01 ' + time, fmt);
  } else if (time instanceof Date) {
    return dateFormat(time, fmt);
  }
}
export function setCookie(c_name, value, expiredays, domain) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + '=' + escape(value) + (expiredays === null ? '' : ';expires=' + exdate.toGMTString());
}
export function dateFormat(date) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm';
  if (!date || date && date.toString() === 'Invalid Date') return null;
  if (typeof date === 'string' || typeof date === 'number') date = new Date(date);
  var texts = {
    'M+': date.getMonth() + 1,
    // 月
    'd+': date.getDate(),
    // 日
    'h+': date.getHours(),
    // 时
    'm+': date.getMinutes(),
    // 分
    's+': date.getSeconds(),
    // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3),
    // 季
    'S': date.getMilliseconds() // 毫秒
  };

  var week = {
    '0': "\u65E5",
    '1': "\u4E00",
    '2': "\u4E8C",
    '3': "\u4E09",
    '4': "\u56DB",
    '5': "\u4E94",
    '6': "\u516D"
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? "\u661F\u671F" : "\u5468" : '') + week[date.getDay() + '']);
  }
  for (var k in texts) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? texts[k] : ('00' + texts[k]).substr(('' + texts[k]).length));
    }
  }
  return fmt;
}

/**
 * 将毫秒转化为时间数组
 * @param {Number} surtime 单位毫秒
 * @returns {Array} [日，时，分，秒]
 */
export function timeFormatArray(surtime) {
  var day = Math.floor(surtime / (24 * 3600 * 1000));
  var leave1 = surtime % (24 * 3600 * 1000);
  var hours = Math.floor(leave1 / (3600 * 1000)); //计算相差分钟数  
  var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
  var minutes = Math.floor(leave2 / (60 * 1000)); //计算相差秒数  
  var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
  var seconds = Math.round(leave3 / 1000);
  return [day, hours, minutes, seconds];
}
export function parseCountDown(expireTime, now) {
  var leftTime = expireTime - (now || Date.now());
  if (leftTime <= 0) return 0;
  var mins = Math.floor(leftTime / 1000 / 60);
  var secs = Math.floor(leftTime / 1000) % 60;
  return "".concat(mins, "\u5206\u949F").concat(secs, "\u79D2");
}

/**
 * @description 打开地图
 * @param {Object} params
 */
export function openMap(params) {
  var _Drip$constant$uaInfo = Drip.constant.uaInfo,
    IS_DIANPING = _Drip$constant$uaInfo.IS_DIANPING,
    IS_MAOYAN = _Drip$constant$uaInfo.IS_MAOYAN,
    IS_MEITUAN = _Drip$constant$uaInfo.IS_MEITUAN,
    IS_GEWARA = _Drip$constant$uaInfo.IS_GEWARA,
    IS_CMBAPP = _Drip$constant$uaInfo.IS_CMBAPP,
    IS_DouyinShowMicroApp = _Drip$constant$uaInfo.IS_DouyinShowMicroApp;
  var shopId = params.shopId,
    lat = params.lat,
    lng = params.lng,
    address = params.address,
    shopName = params.shopName;
  if (IS_DIANPING) {
    // 点评 app 环境下直接跳 app 地图页面
    Drip.redirect("dianping://picassobox?picassoid=picasso_shopmap/RouteVC-bundle.js&notitlebar=true&disableslideback=true&destlat=".concat(lat, "&destlng=").concat(lng, "&shopuuid=").concat(shopId, "&shopaddress=").concat(address));
  } else if (IS_MEITUAN) {
    // 美团 app 环境下直接跳 app 地图页面（地图用prod环境测试，Test环境获取不到poiId）
    if (KNB.Semver.lt(UA.appVersion, '10.1.400')) {
      location.href = "imeituan://www.meituan.com/map/poi?id=".concat(shopId);
    } else {
      location.href = "imeituan://www.meituan.com/mapchannel/poi/detail?mapsource=cinema&poi_id=".concat(shopId, "&latitude=").concat(lat, "&longitude=").concat(lng, "&coordtype=0");
    }
  } else if (IS_GEWARA) {
    // 格瓦拉调起回地图
    var mapUrl = "gewara://com.gewara.movie/map?name=".concat(shopName, "&address=").concat(address, "&lat=").concat(lat, "&lng=").concat(lng, "&type=drama");
    KNB.openWebview({
      url: encodeURI(mapUrl)
    });
  } else if (IS_CMBAPP) {
    // 招行app内地图预览
    cmblapi.mapPreview({
      posName: shopName,
      posCoordinate: {
        latitude: "".concat(lat),
        longitude: "".concat(lng)
      },
      posAddress: address,
      success: function success(res) {
        console.log('地图预览成功', res);
      },
      fail: function fail(res) {
        console.log('地图预览失败', res);
      }
    });
  } else if (IS_MAOYAN && KNB.Semver.gte(UA.appVersion, '9.20.0')) {
    // 猫眼app
    var mapUrlAddr = "maoyan://maoyan.com/cinema_map?cinemaid=".concat(shopId, "&cinemaname=").concat(shopName, "&address=").concat(address, "&cinema_addr=").concat(address, "&lat=").concat(lat, "&lng=").concat(lng);
    var a = document.createElement('a');
    a.href = mapUrlAddr;
    a.click();
    return;
  } else if (IS_DouyinShowMicroApp) {
    // 抖音演出小程序
    window.tt.miniProgram.openLocation({
      latitude: lat,
      longitude: lng,
      address: address,
      name: shopName
    });
    return;
  } else {
    // 其他
    location.href = "https://apis.map.qq.com/uri/v1/marker?marker=coord:".concat(lat, ",").concat(lng, ";title:").concat(shopName, ";addr:").concat(address, "&referer=myshow");
  }
}

/**
 *
 * @param {string} text 复制的文本
 * @returns {Boolean} true: 复制成功； false: 复制失败
 */
export function copyTextToClipboard(text) {
  try {
    var input = document.createElement('input');
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('value', text);
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    return document.body.removeChild(input) ? true : false;
  } catch (error) {
    return false;
  }
}
export function formatPositionItem(list) {
  return list.map(function (item, i) {
    (item.materialItems || item.materialVOList || []).forEach(function (keyItem) {
      var key = keyItem.code || keyItem.key;
      item[key] = keyItem.value;
    });
    return item;
  });
}

/**
 * rgb 转化为hsl Array
 * @param {number} r
 * @param {number} g
 * @param {number} b
 * @returns {Array}
 */
export function rgbToHsl(r, g, b) {
  r /= 255, g /= 255, b /= 255;
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    l = (max + min) / 2;
  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  h = Math.floor(360 * h);
  s = Math.floor(100 * s);
  l = Math.floor(100 * l);
  return [h, s, l];
}
/**
 * @param {Array} hslArr
 * @returns {String} hsl string
 */
export function hslToString(hslArr) {
  return "hsl(".concat(hslArr[0], ", ").concat(hslArr[1], "%, ").concat(hslArr[2], "%)");
}
/**
 * rgb 转化为hsb Array
 * @param {Array} rgb
 * @returns {Array}
 */
export function rgbToHsb(arr) {
  var h = 0,
    s = 0,
    v = 0;
  var r = arr[0],
    g = arr[1],
    b = arr[2];
  arr.sort(function (a, b) {
    return a - b;
  });
  var max = arr[2];
  var min = arr[0];
  v = max / 255;
  if (max === 0) {
    s = 0;
  } else {
    s = 1 - min / max;
  }
  if (max === min) {
    h = 0; // 事实上，max===min的时候，h无论为多少都无所谓
  } else if (max === r && g >= b) {
    h = 60 * ((g - b) / (max - min)) + 0;
  } else if (max === r && g < b) {
    h = 60 * ((g - b) / (max - min)) + 360;
  } else if (max === g) {
    h = 60 * ((b - r) / (max - min)) + 120;
  } else if (max === b) {
    h = 60 * ((r - g) / (max - min)) + 240;
  }
  h = parseInt(h);
  s = parseInt(s * 100);
  v = parseInt(v * 100);
  return [h, s, v];
}

/**
 * hsb 转rgb Array
 * @param {Array} hsb
 * @returns {Array}
 * @param {*} height
 */
export function hsbToRgb(arr) {
  var h = arr[0],
    s = arr[1],
    v = arr[2];
  s = s / 100;
  v = v / 100;
  var r = 0,
    g = 0,
    b = 0;
  var i = parseInt(h / 60 % 6);
  var f = h / 60 - i;
  var p = v * (1 - s);
  var q = v * (1 - f * s);
  var t = v * (1 - (1 - f) * s);
  switch (i) {
    case 0:
      r = v;
      g = t;
      b = p;
      break;
    case 1:
      r = q;
      g = v;
      b = p;
      break;
    case 2:
      r = p;
      g = v;
      b = t;
      break;
    case 3:
      r = p;
      g = q;
      b = v;
      break;
    case 4:
      r = t;
      g = p;
      b = v;
      break;
    case 5:
      r = v;
      g = p;
      b = q;
      break;
    default:
      break;
  }
  r = parseInt(r * 255.0);
  g = parseInt(g * 255.0);
  b = parseInt(b * 255.0);
  return [r, g, b];
}
export function imgCut(url, width, height) {
  // 正方形时 可不传 height 值
  height = height || width;
  // 美团云图片大小处理
  if (/\@/.test(url)) return url;else if (/meituan.net/.test(url)) return "".concat(url, "@").concat(width, "w_").concat(height, "h_1c_1e");
  return url;
}
export function encryptIDNumber(id) {
  if (id.length > 8) {
    var leading = id.slice(0, 3);
    var tailing = id.slice(-4);
    return "".concat(leading, "**********").concat(tailing);
  }
  return id;
}
var categoryIdMap = {
  1: "演唱会",
  2: "体育赛事",
  3: "戏曲艺术",
  4: "话剧歌剧",
  5: "舞蹈芭蕾",
  6: "音乐会",
  7: "亲子演出",
  8: "更多精彩",
  9: "休闲展览",
  10: "音乐节",
  11: "演出直播",
  12: "电竞赛事",
  13: "剧本杀",
  14: "游戏剧场"
};
/**
 * 演出类型id
 * @param {number} id
 * @return {string}
 */
export function categoryId2Name(id) {
  return categoryIdMap[id] || '';
}

/**
 * 初始化定时器列表
 *  @param {function} initTask 异步任务
 *  @param {number} timeInterval 更新任务的时间间隔
 */
export function initTimers(initTask) {
  var timeInterval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8 * 1000;
  var extraInf = arguments.length > 2 ? arguments[2] : undefined;
  var timerIdMap = {};
  function removeTimers(ticketId) {
    if (!ticketId) {
      Object.values(timerIdMap).forEach(function (timerId) {
        clearInterval(timerId);
      });
      timerIdMap = {};
    }
    var timerId = timerIdMap[ticketId];
    if (!timerId) return;
    clearInterval(timerId);
  }
  function addTimer(_x, _x2) {
    return _addTimer.apply(this, arguments);
  }
  function _addTimer() {
    _addTimer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ticketId, callback) {
      var needClear,
        time,
        data,
        _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            needClear = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : true;
            time = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : timeInterval;
            if (needClear) {
              this.removeTimers();
            }
            timerIdMap[ticketId] = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var data;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return initTask(ticketId, 3, extraInf);
                  case 2:
                    data = _context.sent;
                    callback(ticketId, data);
                  case 4:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            })), time);
            _context2.next = 6;
            return initTask(ticketId, 3, extraInf);
          case 6:
            data = _context2.sent;
            callback(ticketId, data);
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    return _addTimer.apply(this, arguments);
  }
  return {
    removeTimers: removeTimers,
    addTimer: addTimer
  };
}
/*
 * 获取目标对象中指定 key 的值
 *
 * @param { String | Array } [keys=[]] 指定 key数组， 可为字符串
 * @param { Object } target 目标对象
 * @returns Object 返回指定 key filter 后的对象
 */
export var getObjectProps = function getObjectProps() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var target = arguments.length > 1 ? arguments[1] : undefined;
  if (!(typeof keys === 'string' || Array.isArray(keys))) throw Error('属性值参数传递有误！');
  if (!Object.prototype.toString.call(target) === '[object Object]') throw Error('目标对象需要为Object对象类型，且不为空！');
  keys = typeof keys === 'string' ? [keys] : keys;
  return keys.reduce(function (r, k) {
    return Object.assign({}, r, _defineProperty({}, k, target[k]));
  }, {});
};
/**
 * 比较两个版本的大小
 * @param {string} versionA 要比较的版本，KNB.Semver的第二个参数
 * @param {string} cmpType 比较类型
 */
export function verisonCompare(versionA) {
  var cmpType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'gte';
  var _success = null;
  var resultPromise = new Promise(function (resolve) {
    _success = resolve;
  });
  KNB.getAppInfo({
    success: function success(_ref2) {
      var version = _ref2.version;
      _success(KNB.Semver[cmpType](version, versionA));
    },
    fail: function fail(err) {
      _success(false);
    }
  });
  return resultPromise;
}

/**
 * @desc 解析url参数
 * @param
 * @return
 * @author xufeiyang
 * @time 2020-08-18
 */
export var parseUrl = function parseUrl(_url) {
  var pattern = /(\w+)=([\w|%]+)/ig; // 定义正则表达式
  var params = {};
  _url.replace(pattern, function (a, b, c) {
    params[b] = c;
  });
  return params; //返回这个数组.
};

/**
 * @desc 判读是tentent活体认证返回
 * @param
 * @return
 * @author xufeiyang
 * @time 2020-09-04
 */
export var isBackFromTectent = function isBackFromTectent(url) {
  return /orderNo.*signature.*code/g.test(url);
};
export function throttle(fn, wait) {
  var callback = fn;
  var timerId = null;

  // 是否是第一次执行
  var firstInvoke = true;
  function throttled() {
    var context = this;
    var args = arguments;

    // 如果是第一次触发，直接执行
    if (firstInvoke) {
      callback.apply(context, args);
      firstInvoke = false;
      return;
    }

    // 如果定时器已存在，直接返回。
    if (timerId) {
      return;
    }
    timerId = setTimeout(function () {
      clearTimeout(timerId);
      timerId = null;
      callback.apply(context, args);
    }, wait);
  }

  // 返回一个闭包
  return throttled;
}
/**
 * 处理新mweb服务 接口前缀
 * 微信小程序：/mysh/odea   非微信小程序：/my/odea
 * @param {*} url 
 * @returns 
 */

export var formatNewMwebUrl = function formatNewMwebUrl(url) {
  if (!url) return url;
  var newUrl = url;
  var maoyanshReg = /\/maoyansh\/myshow\/ajax/;
  var myshowReg = /\/myshow\/ajax/;
  // 不同渠道url 前缀不同
  if (maoyanshReg.test(url)) {
    newUrl = url.replace('/maoyansh/myshow/ajax', '/mysh/odea');
  } else if (myshowReg.test(url)) {
    newUrl = url.replace('/myshow/ajax', '/my/odea');
  }
  return newUrl;
};
/**
 * mweb拆分- 处理项目详情页url
 * eg: 后端下发详情url "https://h5.51ping.com/app/myshow/#/detail/3167835?isNewPage=false" - > "/detail/3167835?isNewPage=false"
 */
export var parseDetailUrl = function parseDetailUrl(url) {
  if (!url) return url;
  var parseUrl = url.replace(/(.*)\/detail(.*)/, function ($0, $1, $2) {
    return "/detail".concat($2);
  });
  return parseUrl;
};